// removed by extract-text-webpack-plugin
module.exports = {"report-charts":"report-charts","report-chart-title":"report-chart-title","report-chart-title-number":"report-chart-title-number","chart-sub-title":"chart-sub-title","chart-sub-tag":"chart-sub-tag","report-chart-buttons":"report-chart-buttons","report-chart-data":"report-chart-data","active":"active","report-chart-size":"report-chart-size","report-chart-flow":"report-chart-flow","report-chart-report":"report-chart-report"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/BarEcharts/Index.scss
// module id = 1378
// module chunks = 0